import { OPTIMIZATION_TYPE_TO_SEPARATE_OPTIONS_MAP } from 'features/cluster/workload-optimization/_constants';
import { OptimizationType } from 'features/workload-optimization';
import { useUpdateWorkloadMutationV2 } from 'hooks/mutations/workload-optimization/useUpdateWorkloadV2Mutation';

import { buildWorkloadConfigPatch } from './_utils';
import { getRightsizingManagementOption } from '../../../_utils';
import { useHpaV2Status } from '../../useHpaV2Status';

import { useCluster } from '@cast/shared-cluster-context-data-access';

export const useToggleWorkloadOptimization = ({
  workloadId,
}: {
  workloadId: string;
}) => {
  const { cluster } = useCluster();
  const { mutate } = useUpdateWorkloadMutationV2();
  const { hpaV2Status } = useHpaV2Status();

  const revertToPolicy = () =>
    mutate({
      clusterId: cluster.id,
      workloadId: workloadId,
      workload: buildWorkloadConfigPatch({
        vpaEnabled: undefined,
        hpaEnabled: undefined,
        hpaV2Status,
      }),
    });

  const toggleManagementOption = ({
    typeToApply,
  }: {
    typeToApply: OptimizationType;
  }) =>
    mutate({
      clusterId: cluster.id,
      workloadId: workloadId,
      // If it is NOT HPAv2 cluster hpa state will be ignored
      workload: buildWorkloadConfigPatch({
        ...OPTIMIZATION_TYPE_TO_SEPARATE_OPTIONS_MAP[typeToApply],
        hpaV2Status,
      }),
    });

  const revertToPolicyV1 = () =>
    mutate({
      clusterId: cluster.id,
      workloadId: workloadId,
      workload: {
        workloadConfig: {
          vpaConfig: {
            managementOption: undefined,
          },
        },
      },
    });

  const toggleVpaOptionV1 = ({ value }: { value: boolean }) =>
    mutate({
      clusterId: cluster.id,
      workloadId: workloadId,
      // If it is NOT HPAv2 cluster hpa state will be ignored
      workload: {
        workloadConfig: {
          vpaConfig: {
            managementOption: getRightsizingManagementOption(!value),
          },
        },
      },
    });

  return {
    revertToPolicy,
    toggleManagementOption,
    revertToPolicyV1,
    toggleVpaOptionV1,
  };
};
